import moment from 'moment'

export const isValidUrl = url => {
  try {
    new URL(url)
  } catch (e) {
    console.error(e)
    return false
  }
  return true
}

export const getFieldData = async fieldName => {
  // switch (fieldName) {
  //   case 'ProvinceId':
  //     const provinces = await CommonRepository.GetListProvince()
  //     const result = provinces.data.map(p => ({
  //                                     id: p.id,
  //                                     value: p.id.toString(),
  //                                     displayValue: p.code,
  //                                     displayText: p.name
  //                                   }))
  //     return result;
  //   default:
  //     return [];
  // }
  return []
}

export const getInnerText = ele => ele?.props?.children?.toString()

export const compare = (a, b, returnValue) => {
  a = getInnerText(a) ?? a ?? ''
  b = getInnerText(b) ?? b ?? ''
  // console.log(a)
  returnValue = returnValue ?? 1
  return typeof a == 'string' && typeof b == 'string' ? a.localeCompare(b) * returnValue : a > b ? returnValue : a < b ? -returnValue : 0
}

export const defaultValue = val => {
  return typeof val === 'number' ? 0 : typeof val === 'string' ? '' : typeof val === 'boolean' ? false : ''
}

export const setDefaultValue = obj => {
  let newObj = { ...obj }
  Object.entries(newObj).map(entry => {
    let value = newObj[entry[0]]
    newObj[entry[0]] = value ?? defaultValue(value)
  })
  return newObj
}

export const isEqual = (obj1, obj2) => {
  const strObj1 = JSON.stringify(obj1)
  const strObj2 = JSON.stringify(obj2)
  return strObj1 === strObj2
}

export const toDateString = (date: Date) => (date ? moment(date).format('DD/MM/YYYY') : '')
export const toDateTimeString = (date: Date) => (date ? moment(date).format('DD/MM/YYYY HH:mm') : '')
export const toDateTimeAllString = (date: Date) => (date ? moment(date).format('DD/MM/YYYY HH:mm:ss.sss') : '')

export const toNumberString = (number: number) => new Intl.NumberFormat('vi-VN').format(number ?? 0)
export const toCurrencyString = (number: number) => new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(number ?? 0)

export type ImageSizeName = 'pico' | 'icon' | 'thumb' | 'small' | 'compact' | 'medium' | 'large' | 'grande' | '1024x1024' | '2048x2048' | 'master'
export const resizeImage = (src, sizeName: ImageSizeName) => {
  if (src) {
    const srcParts = src.split('.')
    const ext = srcParts[srcParts.length - 1]
    const name = src.replace(`.${ext}`, '')
    if (name && ext) return `${name}_${sizeName}.${ext}`
  }
  return getNotFoundImage()
}

export const getNotFoundImage = () =>
  'data:image/png;base64,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'

export const getUrlAccount = () => 'https://accounts.hara.vn'

export enum IFilterType {
  shop = "shop",
  apps = "apps",
  transactions = "transactions",
  payouts = "payouts"
}

export const removeAccents = (str) => {
  return str.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd').replace(/Đ/g, 'D');
}

export const scrollToElementById = (id) => {
  const element = document.getElementById(id);
  element?.scrollIntoView({ behavior: 'smooth' })
}

export const scrollToElementsByClassName = (_class) => {
  const element = document.getElementsByClassName(_class);
  element[0]?.scrollIntoView({behavior: 'smooth' })
}
